import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { TRANSPORT_VOUCHERS_ACTIONS } from "../../../../redux/transportVouchers/actions";
import TransportVouchersForm from "../../../forms/TransportVouchersForm";
import {
  transportVouchersCreating,
  transportVouchersErrors
} from "../../../../redux/transportVouchers/selectors";

class TransportVouchersCreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCreating: this.props.isCreating
    };

    this._handleSubmit = this._handleSubmit.bind(this);
  }

  static propTypes = {
    createRequest: PropTypes.func,
    isCreating: PropTypes.bool,
    location: PropTypes.object,
    ajaxErrors: PropTypes.object,
    resetErrors: PropTypes.func,
    profileGroups: PropTypes.array,
    event: PropTypes.object,
    "event.id": PropTypes.number,
    "location.search": PropTypes.string
  };

  UNSAFE_componentWillMount() {}

  componentWillUnmount() {
    this.props.resetErrors();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      isCreating: nextProps.isCreating
    });
  }

  _handleSubmit(values) {
    const { body } = values;
    const eventId = this.props.event.id;
    const data = {
      eventId,
      body,
      subject: "none"
    };

    this.props.createRequest(data, values.redirect);
  }

  render() {
    const { isCreating, ajaxErrors, event } = this.props;

    return (
      <div className="m-portlet">
        <div className="m-portlet__head">
          <div className="m-portlet__head-caption">
            <div className="m-portlet__head-title">
              <span className="m-portlet__head-icon">
                <i className="flaticon-information" />
              </span>
              <h3 className="m-portlet__head-text">Create Transport Voucher</h3>
            </div>
          </div>
        </div>
        <TransportVouchersForm
          onSubmit={this._handleSubmit}
          formSubmitting={isCreating}
          ajaxErrors={ajaxErrors}
          event={event}
        />
      </div>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    isCreating: transportVouchersCreating(state),
    ajaxErrors: transportVouchersErrors(state)
  };
};

const mapDispatchToProps = dispatch => ({
  createRequest: (values, redirect) =>
    dispatch(TRANSPORT_VOUCHERS_ACTIONS.createRequest(values, redirect)),
  resetErrors: () => dispatch(TRANSPORT_VOUCHERS_ACTIONS.resetErrors())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransportVouchersCreate);
